import {
  ExtensionTag,
  NodeExtension,
  isElementDomNode,
  extension,
  uniqueId,
} from 'remirror'

import type { ComponentType } from 'react'
import type { NodeViewComponentProps } from '@remirror/react'
import type {
  ApplySchemaAttributes,
  NodeExtensionSpec,
  NodeSpecOverride,
} from 'remirror'

import { BLOCK_DATA_ATTRIBUTE, EXTENSION_NAME } from './utils'
import WrapperNodeView from './WrapperNodeView'

@extension({
  defaultOptions: {},
})
class KeyValueBlockExtensionWrapper extends NodeExtension {
  get name() {
    return `${EXTENSION_NAME}-wrapper`
  }

  ReactComponent: ComponentType<NodeViewComponentProps> = WrapperNodeView

  createTags() {
    return [ExtensionTag.Block]
  }

  createNodeSpec(
    extra: ApplySchemaAttributes,
    override: NodeSpecOverride
  ): NodeExtensionSpec {
    return {
      attrs: {
        ...extra.defaults(),
        key: { default: null },
        id: { default: null },
      },
      // key-value-block can only contain `key_value_block` group, refer `key-value-block.ts` schema
      content: 'key_value_block*',
      defining: true,
      selectable: false,
      isolating: true,
      ...override,
      parseDOM: [
        {
          tag: `[${BLOCK_DATA_ATTRIBUTE}]`,
          attrs: {},
          getAttrs: node => {
            if (!isElementDomNode(node)) {
              return false
            }

            const key =
              node.attributes.getNamedItem(BLOCK_DATA_ATTRIBUTE)?.value
            const id = uniqueId('key-value-block-')

            return { ...extra.parse(node), key, id }
          },
        },
      ],
      toDOM: node => {
        const attr = {
          'data-id': node.attrs.id,
          [BLOCK_DATA_ATTRIBUTE]: node.attrs.key,
        }
        return ['div', attr, 0]
      },
    }
  }
}

export default KeyValueBlockExtensionWrapper
